export default "__VITE_ASSET__ea9af7f0__"